import theme from '../../base';

const tooltip = {
  background: theme.colors.neutrals.gray200,
  foreground: theme.colors.neutrals.gray800,
};

export default tooltip;
